module.exports = __webpack_public_path__ + "files/31f15875975aab69085470aabbfec802.png";


/*****************
 ** WEBPACK FOOTER
 ** ./images/next.png
 ** module id = 818
 ** module chunks = 0
 **/